import { AnyAction } from 'redux';
import { AxiosPromise, AxiosResponse } from 'axios';
import { ServerResponse } from 'data/types';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'data/root.reducers';

export const API_PATH_RADIUS_PARSER_PASSWORD = '/password';

export const SET_RADIUS_PARSER_PASSWORD_LOADING = 'SET_RADIUS_PARSER_PASSWORD_LOADING';

export const GO_TO_RADIUS_PARSER_PASSWORD_CREATE = 'GO_TO_RADIUS_PARSER_PASSWORD_CREATE';
export const GO_TO_RADIUS_PARSER_PASSWORD_EDIT = 'GO_TO_RADIUS_PARSER_PASSWORD_EDIT';
export const GO_TO_RADIUS_PARSER_PASSWORD_VIEW = 'GO_TO_RADIUS_PARSER_PASSWORD_VIEW';

export const CREATE_RADIUS_PARSER_PASSWORD = 'CREATE_RADIUS_PARSER_PASSWORD';
export const CREATE_RADIUS_PARSER_PASSWORD_PENDING = 'CREATE_RADIUS_PARSER_PASSWORD_PENDING';
export const CREATE_RADIUS_PARSER_PASSWORD_FULFILLED = 'CREATE_RADIUS_PARSER_PASSWORD_FULFILLED';
export const CREATE_RADIUS_PARSER_PASSWORD_REJECTED = 'CREATE_RADIUS_PARSER_PASSWORD_REJECTED';

export const GET_RADIUS_PARSER_PASSWORD = 'GET_RADIUS_PARSER_PASSWORD';
export const GET_RADIUS_PARSER_PASSWORD_PENDING = 'GET_RADIUS_PARSER_PASSWORD_PENDING';
export const GET_RADIUS_PARSER_PASSWORD_FULFILLED = 'GET_RADIUS_PARSER_PASSWORD_FULFILLED';
export const GET_RADIUS_PARSER_PASSWORD_REJECTED = 'GET_RADIUS_PARSER_PASSWORD_REJECTED';

export const UPDATE_RADIUS_PARSER_PASSWORD = 'UPDATE_RADIUS_PARSER_PASSWORD';
export const UPDATE_RADIUS_PARSER_PASSWORD_PENDING = 'UPDATE_RADIUS_PARSER_PASSWORD_PENDING';
export const UPDATE_RADIUS_PARSER_PASSWORD_FULFILLED = 'UPDATE_RADIUS_PARSER_PASSWORD_FULFILLED';
export const UPDATE_RADIUS_PARSER_PASSWORD_REJECTED = 'UPDATE_RADIUS_PARSER_PASSWORD_REJECTED';

export const DELETE_RADIUS_PARSER_PASSWORD = 'DELETE_RADIUS_PARSER_PASSWORD';
export const DELETE_RADIUS_PARSER_PASSWORD_PENDING = 'DELETE_RADIUS_PARSER_PASSWORD_PENDING';
export const DELETE_RADIUS_PARSER_PASSWORD_FULFILLED = 'DELETE_RADIUS_PARSER_PASSWORD_FULFILLED';
export const DELETE_RADIUS_PARSER_PASSWORD_REJECTED = 'DELETE_RADIUS_PARSER_PASSWORD_REJECTED';

export enum RadiusParserPasswordPrivileges {
  View = 'dc_access',
  Edit = 'dc_access',
  Delete = 'dc_access',
}

export interface RadiusParserPassword {
  id: string,
  usage: string,
  password: string,
  trclvl: string,
  module: string,
  state: string,
  access?: string,
  owner?: string,
  group?: string,
}

export interface RadiusParserPasswordState {
  single: RadiusParserPassword | undefined
  ui: RadiusParserPasswordsUIState
}

export interface RadiusParserPasswordsUIState {
  isLoading: boolean
  isSaving: boolean
}

export interface CreateRadiusParserPasswordThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface CreateRadiusParserPasswordAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_PASSWORD
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface CreateRadiusParserPasswordPendingAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_PASSWORD_PENDING
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface CreateRadiusParserPasswordFulfilledAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_PASSWORD_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface CreateRadiusParserPasswordRejectedAction extends AnyAction {
  type: typeof CREATE_RADIUS_PARSER_PASSWORD_REJECTED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface SetRadiusParserPasswordLoadingAction extends AnyAction {
  type: typeof SET_RADIUS_PARSER_PASSWORD_LOADING
  payload: { isLoading: boolean }
}

export interface GetRadiusParserPasswordAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_PASSWORD
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface GetRadiusParserPasswordPendingAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_PASSWORD_PENDING
  payload: null
}

export interface GetRadiusParserPasswordFulfilledAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_PASSWORD_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface GetRadiusParserPasswordRejectedAction extends AnyAction {
  type: typeof GET_RADIUS_PARSER_PASSWORD_REJECTED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface UpdateRadiusParserPasswordThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface UpdateRadiusParserPasswordAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_PASSWORD
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface UpdateRadiusParserPasswordPendingAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_PASSWORD_PENDING
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface UpdateRadiusParserPasswordFulfilledAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_PASSWORD_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface UpdateRadiusParserPasswordRejectedAction extends AnyAction {
  type: typeof UPDATE_RADIUS_PARSER_PASSWORD_REJECTED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface DeleteRadiusParserPasswordThunkAction extends ThunkAction<void, RootState, void, AnyAction> { }
export interface DeleteRadiusParserPasswordAction extends AnyAction {
  type: typeof DELETE_RADIUS_PARSER_PASSWORD
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface DeleteRadiusParserPasswordPendingAction extends AnyAction {
  type: typeof DELETE_RADIUS_PARSER_PASSWORD_PENDING
  payload: AxiosPromise<ServerResponse<RadiusParserPassword>>
}

export interface DeleteRadiusParserPasswordFulfilledAction extends AnyAction {
  type: typeof DELETE_RADIUS_PARSER_PASSWORD_FULFILLED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export interface DeleteRadiusParserPasswordRejectedAction extends AnyAction {
  type: typeof DELETE_RADIUS_PARSER_PASSWORD_REJECTED
  payload: AxiosResponse<ServerResponse<RadiusParserPassword>>
}

export type RadiusParserPasswordActionTypes =
  SetRadiusParserPasswordLoadingAction |
  GetRadiusParserPasswordAction |
  GetRadiusParserPasswordPendingAction |
  GetRadiusParserPasswordFulfilledAction |
  GetRadiusParserPasswordRejectedAction |
  UpdateRadiusParserPasswordAction |
  UpdateRadiusParserPasswordPendingAction |
  UpdateRadiusParserPasswordFulfilledAction |
  UpdateRadiusParserPasswordRejectedAction |
  DeleteRadiusParserPasswordAction |
  DeleteRadiusParserPasswordPendingAction |
  DeleteRadiusParserPasswordFulfilledAction |
  DeleteRadiusParserPasswordRejectedAction |
  CreateRadiusParserPasswordAction |
  CreateRadiusParserPasswordPendingAction |
  CreateRadiusParserPasswordFulfilledAction |
  CreateRadiusParserPasswordRejectedAction;
